import React from 'react';
import PendingTaskList from './PendingTaskList';
import './PendingTasksModal.css';

// Thin overlay wrapper. The task rendering + actions live in PendingTaskList,
// which the Task Tracking "Available" tab also renders — so the modal and the
// tab always show the same pool with the same actions (single source of truth).
function PendingTasksModal({ isOpen, onClose, pendingTasks, onTaskUpdate, user }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content pending-tasks-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h3>Pending Tasks</h3>
            <p className="modal-subtitle">
              {pendingTasks.length === 0
                ? 'No pending tasks.'
                : `${pendingTasks.length} task${pendingTasks.length === 1 ? '' : 's'} waiting for action`}
            </p>
            {/* This pop-up is a shortcut view of Task Tracking — same records,
                same pool; "Open in Task Tracking" jumps to the task's place. */}
            <p className="modal-subtitle" style={{ fontSize: 12, color: '#6b7280', margin: '2px 0 0' }}>
              Shortcut view of Task Tracking — every task here is the same record you see there; use “Open in Task Tracking” to go to it.
            </p>
          </div>
          <button onClick={onClose} className="modal-close">×</button>
        </div>

        <div className="modal-body">
          <PendingTaskList
            pendingTasks={pendingTasks}
            onTaskUpdate={onTaskUpdate}
            user={user}
            onClose={onClose}
          />
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn btn-outline">Close</button>
        </div>
      </div>
    </div>
  );
}

export default PendingTasksModal;
